<template>
    <ordering-table-orders
        :page-title="$tl('labels.modules.orderingTable.kitchen.title')"
        :page-subtitle="$tl('labels.modules.orderingTable.kitchen.subtitle')"
        :status-options-override="statusOptions"
        default-status="all" />
</template>

<script>
import OrderingTableOrders from "../Orders/OrderingTableOrders.vue";

export default {
    components: {
        OrderingTableOrders,
    },
    computed: {
        statusOptions() {
            return [
                { value: "all", label: this.$tl("labels.modules.orderingTable.orders.filters.all") },
                { value: "preparing", label: this.$tl("labels.modules.orderingTable.orders.status.preparing") },
                { value: "ready", label: this.$tl("labels.modules.orderingTable.orders.status.ready") },
                { value: "served", label: this.$tl("labels.modules.orderingTable.orders.status.served") },
            ];
        },
    },
};
</script>
